// "use client";
// import { useEffect, useState, useCallback } from "react";
// import React from "react";

// export interface GalleryItem {
//   img?: string;
//   title?: string;
//   subTitle?: string;
// }

// export interface Developer {
//   id?: string;
//   _id?: string;
//   developerName: string;
//   developerDescriptionLeft?: string;
//   developerDescriptionRight?: string;
//   isPublished?: boolean;
//   teamTiaUp?: boolean;
//   employerReviewUserId: string;
//   developerImages: string[];
//   developerGallery: GalleryItem[];
//   developerSlug: string;
//   developerLogo: string;
  
//   developerWebsite: string;
//   developerHeadquarters: string;
//   developereStablishedYear: string;
//   developerContactNumbers: string[];
//   developerEmail: string[];
//   developerAddress: string;
//   userId?: string;
//   createdAt?: string;
//   updatedAt?: string;
//   userPostDataInfo?: {
//     name: string;
//     emailId: string;
//     role: string;
//     createdAt: string;
//     updatedAt: string;
//   }[];
// }

// const initialDeveloperState: Developer = {
//   developerName: "",
//   developerDescriptionLeft: "",
//   developerDescriptionRight: "",
//   isPublished: false,
//   teamTiaUp: false,
//   employerReviewUserId: "",
//   developerImages: [],
//   developerGallery: [],
//   developerSlug: "",
//   developerLogo: "",
//   developerWebsite: "",
//   developerHeadquarters: "",
//   developereStablishedYear: "",
//   developerContactNumbers: [],
//   developerEmail: [],
//   developerAddress: "",
// };

// const getImageUrl = (path?: string) => {
//   if (!path) return "";
//   if (path.startsWith("http")) return path;
//   return `https://service.ireedindia.com/image/${path}`;
// };

// const DeveloperDashboard = () => {
//   const storedUser = localStorage.getItem("userDetails");
//   const userDetails = storedUser ? JSON.parse(storedUser) : null;
//   const role = userDetails?.role;

//   const [developers, setDevelopers] = useState<Developer[]>([]);
//   // NEW: State for the search API results
//   const [companyUsers, setCompanyUsers] = useState<{ _id: string; name: string }[]>([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editingDeveloper, setEditingDeveloper] = useState<Developer | null>(null);
//   const [formData, setFormData] = useState<Developer>(initialDeveloperState);
//   const [logoPreview, setLogoPreview] = useState<string>("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [publishFilter, setPublishFilter] = useState<'all' | 'published' | 'unpublished'>('all');

//   const uploadImageToAPI = async (file: File): Promise<string> => {
//     const fd = new FormData();
//     fd.append("file", file);
//     const res = await fetch("https://service.ireedindia.com/upload", {
//       method: "POST",
//       body: fd,
//     });
//     if (!res.ok) throw new Error("Upload failed");
//     const data = await res.json();
//     return data.filename;
//   };

//   const replaceImageToAPI = async (file: File, oldFilename: string): Promise<string> => {
//     const fd = new FormData();
//     fd.append("file", file);
//     fd.append("oldFilenames", oldFilename);
//     const res = await fetch("https://service.ireedindia.com/replace-files", {
//       method: "PATCH",
//       body: fd,
//     });
//     if (!res.ok) throw new Error("Replace failed");
//     const data = await res.json();
//     return data.uploadedFiles;
//   };

//   // NEW: Fetch users from search API
//   const fetchCompanyUsers = async () => {
//     try {
//       const res = await fetch("https://service.ireedindia.com/v1/users/search", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           pageNumber: "0",
//           size: "40",
//           role: ["company"]
//         }),
//       });
//       const data = await res.json();
//       const users = data.content || data.data || (Array.isArray(data) ? data : []);
//       setCompanyUsers(users);
//     } catch (err) {
//       console.error("❌ User search error:", err);
//     }
//   };

//   const fetchDevelopers = async () => {
//     setIsLoading(true);
//     try {
//       const userId = userDetails?.userId;
//       let apiUrl = "https://service.ireedindia.com/v1/developers-all?page=1&limit=1000";
//       if (role !== "admin" && userId) {
//         apiUrl += `?userId=${userId}`;
//       }
//       const res = await fetch(apiUrl);
//       const data = await res.json();
//       if (Array.isArray(data)) setDevelopers(data);
//       else if (data.developers) setDevelopers(data.developers);
//       else if (data.data) setDevelopers(data.data);
//     } catch (err) {
//       console.error("❌ Fetch error:", err);
//       alert("Failed to fetch developers");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => { 
//     fetchDevelopers(); 
//     fetchCompanyUsers(); // Load users on mount
//   }, []);

//   const handleSubmit = async () => {
//     try {
//       setIsLoading(true);
//       const userId = userDetails?.userId;
//       const url = editingDeveloper
//         ? `https://service.ireedindia.com/v1/developers/${editingDeveloper.id || editingDeveloper._id}`
//         : "https://service.ireedindia.com/v1/developer-create";
//       const method = editingDeveloper ? "PATCH" : "POST";

//       let payload: any = { ...formData };
//       if (role !== "admin" && userId) {
//         payload.userId = userId;
//       }

//       if (userDetails && !editingDeveloper) {
//         payload.userPostDataInfo = [
//           {
//             name: userDetails.name || userDetails.username || userDetails.emailId || "",
//             emailId: userDetails.emailId || userDetails.email || "",
//             role: userDetails.role || "",
//             createdAt: new Date().toISOString(),
//             updatedAt: new Date().toISOString(),
//           },
//         ];
//       }

//       const res = await fetch(url, {
//         method,
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });

//       const data = await res.json();
//       if (!res.ok) throw new Error(data.message || "Save failed");

//       alert(`Developer ${editingDeveloper ? "updated" : "created"} successfully`);
//       resetForm();
//       setIsModalOpen(false);
//       fetchDevelopers();
//     } catch (err) {
//       console.error("❌ Save error:", err);
//       alert("Save failed");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const resetForm = useCallback(() => {
//     setFormData(initialDeveloperState);
//     setLogoPreview("");
//     setEditingDeveloper(null);
//   }, []);

//   const handleDelete = async (id?: string) => {
//     if (!id || !window.confirm("Are you sure to delete this developer?")) return;
//     if (role !== "admin") {
//       alert("Only administrators can delete developers");
//       return;
//     }
//     try {
//       setIsLoading(true);
//       const res = await fetch(`https://service.ireedindia.com/v1/developers/${id}`, {
//         method: "DELETE",
//       });
//       if (!res.ok) throw new Error("Delete failed");
//       alert("Deleted successfully");
//       fetchDevelopers();
//     } catch (err) {
//       console.error("❌ Delete error:", err);
//       alert("Delete failed");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleEdit = (dev: Developer) => {
//     setEditingDeveloper(dev);
//     setFormData(dev);
//     setLogoPreview(getImageUrl(dev.developerLogo));
//     setIsModalOpen(true);
//   };

//   const handleLogoUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     try {
//       setIsLoading(true);
//       let filename: string;
//       if (editingDeveloper && formData.developerLogo) {
//         filename = await replaceImageToAPI(file, formData.developerLogo);
//         alert("Logo replaced successfully");
//       } else {
//         filename = await uploadImageToAPI(file);
//       }
//       setFormData({ ...formData, developerLogo: filename });
//       setLogoPreview(getImageUrl(filename));
//     } catch (err) {
//       console.error("Logo upload failed", err);
//       alert("Logo upload failed");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleImagesUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
//     const files = e.target.files;
//     if (!files) return;
//     try {
//       const uploadPromises = Array.from(files).map(uploadImageToAPI);
//       const filenames = await Promise.all(uploadPromises);
//       setFormData((prev) => ({
//         ...prev,
//         developerImages: [...prev.developerImages, ...filenames],
//       }));
//     } catch {
//       alert("Images upload failed");
//     }
//   };

//   const handleImageReplace = async (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     const oldFilename = formData.developerImages[index];
//     if (!oldFilename) return;
//     try {
//       setIsLoading(true);
//       const newFilename = await replaceImageToAPI(file, oldFilename);
//       const updatedImages = [...formData.developerImages];
//       updatedImages[index] = newFilename;
//       setFormData({ ...formData, developerImages: updatedImages });
//       alert("Image replaced successfully");
//     } catch (err) {
//       alert("Image replace failed");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleGalleryUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
//     const files = e.target.files;
//     if (!files) return;
//     try {
//       const uploadPromises = Array.from(files).map(uploadImageToAPI);
//       const filenames = await Promise.all(uploadPromises);
//       const galleryItems = filenames.map((f) => ({ img: f, title: "", subTitle: "" }));
//       setFormData((prev) => ({
//         ...prev,
//         developerGallery: [...prev.developerGallery, ...galleryItems],
//       }));
//     } catch {
//       alert("Gallery upload failed");
//     }
//   };

//   const handleGalleryImageReplace = async (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     const oldFilename = formData.developerGallery[index].img;
//     if (!oldFilename) return;
//     try {
//       setIsLoading(true);
//       const newFilename = await replaceImageToAPI(file, oldFilename);
//       const updatedGallery = [...formData.developerGallery];
//       updatedGallery[index].img = newFilename;
//       setFormData({ ...formData, developerGallery: updatedGallery });
//       alert("Gallery image replaced successfully");
//     } catch (err) {
//       alert("Gallery image replace failed");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   let filteredDevelopers = developers.filter(d =>
//     d.developerName.toLowerCase().includes(searchQuery.toLowerCase())
//   );
//   if (role === 'admin' && publishFilter !== 'all') {
//     filteredDevelopers = filteredDevelopers.filter(d =>
//       publishFilter === 'published' ? d.isPublished : !d.isPublished
//     );
//   }

//   return (
//     <div style={{ minHeight: "100vh", background: "#f5f7fa", padding: "24px" }}>
//       <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
//         {/* Header */}
//         <div style={{ background: "white", padding: "24px", borderRadius: "12px", marginBottom: "24px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
//           <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "16px" }}>
//             <div>
//               <h1 style={{ margin: 0, fontSize: "28px", color: "#1a202c", fontWeight: "600" }}>Developer Dashboard</h1>
//               <p style={{ margin: "4px 0 0 0", color: "#64748b", fontSize: "14px" }}>Manage real estate developers</p>
//             </div>
//             <div style={{ display: "flex", gap: "12px" }}>
//               <div style={{ textAlign: "center", background: "#f8fafc", padding: "12px 20px", borderRadius: "8px", border: "1px solid #e2e8f0" }}>
//                 <div style={{ fontSize: "24px", fontWeight: "600", color: "#1e293b" }}>{developers.length}</div>
//                 <div style={{ fontSize: "11px", color: "#64748b", marginTop: "2px" }}>Total</div>
//               </div>
//               <div style={{ textAlign: "center", background: "#f0fdf4", padding: "12px 20px", borderRadius: "8px", border: "1px solid #bbf7d0" }}>
//                 <div style={{ fontSize: "24px", fontWeight: "600", color: "#15803d" }}>{developers.filter(d => d.isPublished).length}</div>
//                 <div style={{ fontSize: "11px", color: "#15803d", marginTop: "2px" }}>Published</div>
//               </div>
//               <div style={{ textAlign: "center", background: "#fef2f2", padding: "12px 20px", borderRadius: "8px", border: "1px solid #fecaca" }}>
//                 <div style={{ fontSize: "24px", fontWeight: "600", color: "#dc2626" }}>{developers.filter(d => !d.isPublished).length}</div>
//                 <div style={{ fontSize: "11px", color: "#dc2626", marginTop: "2px" }}>Draft</div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Controls */}
//         <div style={{ background: "white", padding: "20px", borderRadius: "12px", marginBottom: "24px", display: "flex", justifyContent: "space-between", alignItems: "center", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", flexWrap: "wrap", gap: "12px" }}>
//           <button onClick={() => { resetForm(); setIsModalOpen(true); }} style={{ padding: "12px 24px", background: "#3b82f6", color: "white", border: "none", borderRadius: "8px", fontSize: "14px", fontWeight: "500", cursor: "pointer" }}>
//             + Add Developer
//           </button>
//           <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
//             <input
//               type="text"
//               placeholder="Search developers..."
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//               style={{ padding: "10px 16px", width: "300px", border: "1px solid #e2e8f0", borderRadius: "8px", fontSize: "14px" }}
//             />
//             {searchQuery && (
//               <button onClick={() => setSearchQuery("")} style={{ padding: "10px 16px", background: "#f1f5f9", color: "#475569", border: "none", borderRadius: "8px", fontSize: "13px", cursor: "pointer" }}>
//                 Clear
//               </button>
//             )}
//             {role === 'admin' && (
//               <div style={{ marginLeft: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
//                 <span style={{ fontWeight: 500, fontSize: 15 }}>Filter:</span>
//                 <select
//                   value={publishFilter}
//                   onChange={e => setPublishFilter(e.target.value as 'all' | 'published' | 'unpublished')}
//                   style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #d1d5db', fontSize: 15 }}
//                 >
//                   <option value="all">All</option>
//                   <option value="published">Published</option>
//                   <option value="unpublished">Unpublished</option>
//                 </select>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Table */}
//         <div style={{ background: "white", borderRadius: "12px", overflow: "auto", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
//           <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
//             <thead>
//               <tr style={{ background: "linear-gradient(to right, #4f46e5, #7c3aed)", color: "white" }}>
//                 <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600" }}>Developer</th>
//                 <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600" }}>Location</th>
//                 <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600" }}>Contact</th>
//                 <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600" }}>Media & Gallery</th>
//                 {role === "admin" && (
//                   <>
//                     <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600" }}>Created By</th>
//                     <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600" }}>Created At</th>
//                     <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600" }}>Updated At</th>
//                   </>
//                 )}
//                 <th style={{ padding: "14px 0px", textAlign: "center", fontSize: "13px", fontWeight: "600" }}>Status</th>
//                 <th style={{ padding: "14px 16px", textAlign: "center", fontSize: "13px", fontWeight: "600" }}>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredDevelopers.map((d) => (
//                 <tr key={d.id || d._id} style={{ borderBottom: "1px solid #e5e7eb" }}>
//                   <td style={{ padding: "14px 16px" }}>
//                     <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//                       {d.developerLogo ? (
//                         <img src={getImageUrl(d.developerLogo)} alt="logo" style={{ width: "48px", height: "48px", objectFit: "contain", borderRadius: "8px", border: "1px solid #e5e7eb", background: "white", padding: "4px" }} />
//                       ) : (
//                         <div style={{ width: "48px", height: "48px", background: "#f3f4f6", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "20px" }}>🏢</div>
//                       )}
//                       <div>
//                         <div style={{ fontWeight: "600", fontSize: "14px", color: "#111827" }}>{d.developerName}</div>
//                         <div style={{ fontSize: "12px", color: "#6b7280" }}>Est. {d.developereStablishedYear || "N/A"}</div>
//                       </div>
//                     </div>
//                   </td>
//                   <td style={{ padding: "14px 16px", fontSize: "13px" }}>
//                     <div>{d.developerHeadquarters || "N/A"}</div>
//                     {d.developerWebsite && <a href={d.developerWebsite} target="_blank" rel="noopener noreferrer" style={{ fontSize: "12px", color: "#4f46e5" }}>View Website →</a>}
//                   </td>
//                   <td style={{ padding: "14px 16px", fontSize: "13px" }}>
//                     {d.developerContactNumbers?.[0] && <div>📞 {d.developerContactNumbers[0]}</div>}
//                     {d.developerEmail?.[0] && <div style={{ fontSize: "12px", color: "#6b7280" }}>✉️ {d.developerEmail[0]}</div>}
//                   </td>
//                   <td style={{ padding: "14px 16px" }}>
//                     <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
//                       {d.developerImages?.slice(0, 3).map((img, idx) => (
//                         <img key={idx} src={getImageUrl(img)} style={{ width: "32px", height: "32px", objectFit: "cover", borderRadius: "4px" }} alt="media" />
//                       ))}
//                     </div>
//                   </td>
//                   {role === "admin" && (
//                     <>
//                       <td style={{ padding: "14px 16px", fontSize: "13px" }}>{d.userPostDataInfo?.[0]?.name || "N/A"}</td>
//                       <td style={{ padding: "14px 16px", fontSize: "12px" }}>{d.userPostDataInfo?.[0]?.createdAt ? new Date(d.userPostDataInfo[0].createdAt).toLocaleDateString() : "N/A"}</td>
//                       <td style={{ padding: "14px 16px", fontSize: "12px" }}>{d.userPostDataInfo?.[0]?.updatedAt ? new Date(d.userPostDataInfo[0].updatedAt).toLocaleDateString() : "N/A"}</td>
//                     </>
//                   )}
//                   <td style={{ padding: "14px 12px", textAlign: "center" }}>
//                     <span style={{ padding: "4px 8px", background: d.isPublished ? "#10b981" : "#ef4444", color: "white", borderRadius: "20px", fontSize: "11px", fontWeight: "600" }}>
//                       {d.isPublished ? "✓ Published" : "✕ Draft"}
//                     </span>
//                   </td>
//                   <td style={{ padding: "14px 16px", textAlign: "center" }}>
//                     <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
//                       <button onClick={() => handleEdit(d)} style={{ padding: "6px 12px", background: "#4f46e5", color: "white", border: "none", borderRadius: "6px", fontSize: "12px", cursor: "pointer" }}>Edit</button>
//                       {role === "admin" && (
//                         <button onClick={() => handleDelete(d.id || d._id)} style={{ padding: "6px 12px", background: "#ef4444", color: "white", border: "none", borderRadius: "6px", fontSize: "12px", cursor: "pointer" }}>Delete</button>
//                       )}
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         {/* Modal */}
//         {isModalOpen && (
//           <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000, padding: "20px" }}>
//             <div style={{ background: "white", borderRadius: "16px", width: "100%", maxWidth: "900px", maxHeight: "90vh", overflow: "auto" }}>
//               {/* Modal Header */}
//               <div style={{ padding: "24px", borderBottom: "1px solid #e2e8f0", position: "sticky", top: 0, background: "white", zIndex: 10 }}>
//                 <h2 style={{ margin: 0, fontSize: "24px", color: "#1a202c", fontWeight: "600" }}>
//                   {editingDeveloper ? "Edit Developer" : "Add New Developer"}
//                 </h2>
//               </div>

//               {/* Modal Body */}
//               <div style={{ padding: "24px" }}>
//                 {/* Basic Information */}
//                 <Section title="Basic Information">
//                   <FormField label="Developer Name" required>
//                     <input value={formData.developerName} onChange={(e) => setFormData({ ...formData, developerName: e.target.value })} style={inputStyle} placeholder="Enter developer name" />
//                   </FormField>

//                   <FormField label="Slug" required>
//                     <input value={formData.developerSlug} onChange={(e) => setFormData({ ...formData, developerSlug: e.target.value })} style={inputStyle} placeholder="developer-slug" />
//                   </FormField>

//                   <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
//                     <FormField label="Website" required>
//                       <input value={formData.developerWebsite} onChange={(e) => setFormData({ ...formData, developerWebsite: e.target.value })} style={inputStyle} placeholder="https://example.com" />
//                     </FormField>
//                     <FormField label="Established Year" required>
//                       <input value={formData.developereStablishedYear} onChange={(e) => setFormData({ ...formData, developereStablishedYear: e.target.value })} style={inputStyle} placeholder="2020" />
//                     </FormField>
//                   </div>

//                   <FormField label="Headquarters" required>
//                     <input value={formData.developerHeadquarters} onChange={(e) => setFormData({ ...formData, developerHeadquarters: e.target.value })} style={inputStyle} placeholder="City, Country" />
//                   </FormField>

//                   <FormField label="Address" required>
//                     <textarea value={formData.developerAddress} onChange={(e) => setFormData({ ...formData, developerAddress: e.target.value })} style={{ ...inputStyle, minHeight: "80px" }} placeholder="Full address" rows={3} />
//                   </FormField>
//                 </Section>

//                 {/* Description */}
//                 <Section title="Description">
//                   <FormField label="Description Left" required>
//                     <textarea value={formData.developerDescriptionLeft} onChange={(e) => setFormData({ ...formData, developerDescriptionLeft: e.target.value })} style={{ ...inputStyle, minHeight: "120px" }} placeholder="Enter left description 50 words" rows={5} />
//                   </FormField>
//                   <FormField label="Description Right" required>
//                     <textarea value={formData.developerDescriptionRight} onChange={(e) => setFormData({ ...formData, developerDescriptionRight: e.target.value })} style={{ ...inputStyle, minHeight: "120px" }} placeholder="Enter right description 95 words" rows={5} />
//                   </FormField>
//                 </Section>

//                 {/* Contact Information */}
//                 <Section title="Contact Information">
//                   <FormField label="Contact Numbers" required>
//                     <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
//                       {formData.developerContactNumbers.map((num, i) => (
//                         <div key={i} style={{ display: "flex", gap: "8px" }}>
//                           <input value={num} onChange={(e) => {
//                             const updated = [...formData.developerContactNumbers];
//                             updated[i] = e.target.value;
//                             setFormData({ ...formData, developerContactNumbers: updated });
//                           }} style={{ ...inputStyle, flex: 1 }} />
//                           <button onClick={() => {
//                             const updated = formData.developerContactNumbers.filter((_, idx) => idx !== i);
//                             setFormData({ ...formData, developerContactNumbers: updated });
//                           }} style={removeBtn}>Remove</button>
//                         </div>
//                       ))}
//                       <button onClick={() => setFormData({ ...formData, developerContactNumbers: [...formData.developerContactNumbers, ""] })} style={addBtn}>+ Add Contact Number</button>
//                     </div>
//                   </FormField>

//                   <FormField label="Email Addresses" required>
//                     <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
//                       {formData.developerEmail.map((email, i) => (
//                         <div key={i} style={{ display: "flex", gap: "8px" }}>
//                           <input value={email} onChange={(e) => {
//                             const updated = [...formData.developerEmail];
//                             updated[i] = e.target.value;
//                             setFormData({ ...formData, developerEmail: updated });
//                           }} style={{ ...inputStyle, flex: 1 }} />
//                           <button onClick={() => {
//                             const updated = formData.developerEmail.filter((_, idx) => idx !== i);
//                             setFormData({ ...formData, developerEmail: updated });
//                           }} style={removeBtn}>Remove</button>
//                         </div>
//                       ))}
//                       <button onClick={() => setFormData({ ...formData, developerEmail: [...formData.developerEmail, ""] })} style={addBtn}>+ Add Email</button>
//                     </div>
//                   </FormField>
//                 </Section>

//                 {/* Media */}
//                 <Section title="Media">
//                   <FormField label="Logo" required>
//                     <div style={{ border: "2px dashed #e2e8f0", padding: "24px", borderRadius: "12px", textAlign: "center", background: "#fafbfc" }}>
//                       <input type="file" accept="image/*" onChange={handleLogoUpload} style={{ marginBottom: "12px" }} />
//                       {logoPreview && (
//                         <div style={{ marginTop: "16px" }}>
//                           <img src={logoPreview} style={{ maxWidth: "150px", maxHeight: "150px", objectFit: "contain", border: "1px solid #e2e8f0", borderRadius: "8px", padding: "8px", background: "white" }} alt="Logo preview" />
//                         </div>
//                       )}
//                     </div>
//                   </FormField>

//                   <FormField label="Developer Images">
//                     <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
//                       <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))", gap: "12px" }}>
//                         {formData.developerImages.map((img, i) => (
//                           <div key={i} style={{ position: "relative", borderRadius: "8px", overflow: "hidden", border: "1px solid #e2e8f0" }}>
//                             <img src={getImageUrl(img)} style={{ width: "100%", height: "120px", objectFit: "cover" }} alt="media" />
//                             <div style={{ position: "absolute", top: "4px", right: "4px", display: "flex", gap: "4px" }}>
//                               <button onClick={() => {
//                                 const updated = formData.developerImages.filter((_, idx) => idx !== i);
//                                 setFormData({ ...formData, developerImages: updated });
//                               }} style={{ background: "#ef4444", color: "white", border: "none", borderRadius: "4px", cursor: "pointer", padding: "4px 8px" }}>×</button>
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                       <input type="file" accept="image/*" multiple onChange={handleImagesUpload} id="developer-images-upload" style={{ display: "none" }} />
//                       <button onClick={() => (document.getElementById('developer-images-upload') as HTMLInputElement)?.click()} style={addBtn}>+ Add Images</button>
//                     </div>
//                   </FormField>

//                   <FormField label="Gallery">
//                     <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
//                       <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "16px" }}>
//                         {formData.developerGallery.map((g, i) => (
//                           <div key={i} style={{ border: "1px solid #e2e8f0", borderRadius: "12px", padding: "12px", background: "white" }}>
//                             <img src={getImageUrl(g.img)} style={{ width: "100%", height: "140px", objectFit: "cover", borderRadius: "8px", marginBottom: "8px" }} alt="gallery" />
//                             <input placeholder="Title" value={g.title} onChange={(e) => {
//                               const updated = [...formData.developerGallery];
//                               updated[i].title = e.target.value;
//                               setFormData({ ...formData, developerGallery: updated });
//                             }} style={{ ...inputStyle, marginBottom: "8px" }} />
//                             <input placeholder="Subtitle" value={g.subTitle} onChange={(e) => {
//                               const updated = [...formData.developerGallery];
//                               updated[i].subTitle = e.target.value;
//                               setFormData({ ...formData, developerGallery: updated });
//                             }} style={{ ...inputStyle, marginBottom: "8px" }} />
//                             <button onClick={() => {
//                               const updated = formData.developerGallery.filter((_, idx) => idx !== i);
//                               setFormData({ ...formData, developerGallery: updated });
//                             }} style={{ ...removeBtn, width: "100%", justifyContent: "center" }}>Remove</button>
//                           </div>
//                         ))}
//                       </div>
//                       <input type="file" accept="image/*" multiple onChange={handleGalleryUpload} id="gallery-upload" style={{ display: "none" }} />
//                       <button onClick={() => (document.getElementById('gallery-upload') as HTMLInputElement)?.click()} style={addBtn}>+ Add Gallery Images</button>
//                     </div>
//                   </FormField>
//                 </Section>

//                 <FormField label="Employer Review User">
//                   {/* API INTEGRATED SELECT */}
//                   <select 
//                     value={formData.employerReviewUserId} 
//                     onChange={(e) => setFormData({ ...formData, employerReviewUserId: e.target.value })} 
//                     style={{ ...inputStyle, appearance: "auto" }}
//                   >
//                     <option value="">Select a User</option>
//                     {companyUsers.map((user) => (
//                       <option key={user._id} value={user._id}>
//                         {user.name}
//                       </option>
//                     ))}
//                   </select>
//                 </FormField>

//                 {role === "admin" && (
//                   <Section title="Publishing & Partnerships">
//                     <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
//                       <label style={{ display: "flex", alignItems: "center", gap: "12px", cursor: "pointer" }}>
//                         <input type="checkbox" checked={formData.isPublished} onChange={(e) => setFormData({ ...formData, isPublished: e.target.checked })} style={{ width: "20px", height: "20px" }} />
//                         <span style={{ fontSize: "14px", fontWeight: "500" }}>Publish this developer</span>
//                       </label>
//                       <label style={{ display: "flex", alignItems: "center", gap: "12px", cursor: "pointer" }}>
//                         <input type="checkbox" checked={formData.teamTiaUp} onChange={(e) => setFormData({ ...formData, teamTiaUp: e.target.checked })} style={{ width: "20px", height: "20px" }} />
//                         <span style={{ fontSize: "14px", fontWeight: "500" }}>Team Tia Up</span>
//                       </label>
//                     </div>
//                   </Section>
//                 )}
//               </div>

//               {/* Modal Footer */}
//               <div style={{ padding: "20px 24px", borderTop: "1px solid #e2e8f0", display: "flex", justifyContent: "flex-end", gap: "12px", position: "sticky", bottom: 0, background: "white" }}>
//                 <button onClick={() => setIsModalOpen(false)} style={{ padding: "12px 24px", background: "#f1f5f9", color: "#475569", border: "none", borderRadius: "8px", cursor: "pointer" }}>Cancel</button>
//                 <button onClick={handleSubmit} disabled={isLoading} style={{ padding: "12px 24px", background: "#3b82f6", color: "white", border: "none", borderRadius: "8px", cursor: "pointer" }}>
//                   {isLoading ? "Saving..." : editingDeveloper ? "Update Developer" : "Create Developer"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// const Section = ({ title, children }: { title: string; children: React.ReactNode }) => (
//   <div style={{ marginBottom: "32px" }}>
//     <div style={{ marginBottom: "20px" }}>
//       <h3 style={{
//         fontSize: "16px",
//         fontWeight: "600",
//         color: "#1e293b",
//         background: "linear-gradient(90deg, transparent 0%, #dbeafe 20%, #dbeafe 80%, transparent 100%)",
//         padding: "10px 20px",
//         borderRadius: "24px",
//         display: "inline-block"
//       }}>{title}</h3>
//     </div>
//     <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>{children}</div>
//   </div>
// );

// const FormField = ({ label, required, children }: { label: string; required?: boolean; children: React.ReactNode }) => (
//   <div>
//     <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "500", color: "#475569" }}>
//       {label} {required && <span style={{ color: "#ef4444" }}>*</span>}
//     </label>
//     {children}
//   </div>
// );

// const inputStyle: React.CSSProperties = {
//   width: "100%",
//   padding: "10px 14px",
//   border: "1px solid #e2e8f0",
//   borderRadius: "8px",
//   fontSize: "14px",
// };

// const addBtn: React.CSSProperties = {
//   padding: "10px 18px",
//   background: "#f1f5f9",
//   color: "#475569",
//   border: "1px solid #e2e8f0",
//   borderRadius: "8px",
//   fontSize: "13px",
//   cursor: "pointer",
// };

// const removeBtn: React.CSSProperties = {
//   padding: "10px 18px",
//   background: "#fee2e2",
//   color: "#dc2626",
//   border: "none",
//   borderRadius: "8px",
//   fontSize: "13px",
//   cursor: "pointer",
// };

// export default DeveloperDashboard;


"use client";
import { useEffect, useState, useCallback } from "react";
import React from "react";

export interface GalleryItem {
  img?: string;
  title?: string;
  subTitle?: string;
}

export interface AssessmentPdfItem {
  title: string;
  pdf: string;
}

export interface Developer {
  id?: string;
  _id?: string;
  developerName: string;
  developerDescriptionLeft?: string;
  developerDescriptionRight?: string;
  isPublished?: boolean;
  teamTiaUp?: boolean;
  employerReviewUserId: string;
  developerImages: string[];
  developerGallery: GalleryItem[];
  developerSlug: string;
  developerLogo: string;
  
  developerWebsite: string;
  developerHeadquarters: string;
  developereStablishedYear: string;
  developerContactNumbers: string[];
  developerEmail: string[];
  developerAddress: string;
  teamAssementPdfModule: AssessmentPdfItem[];
  userId?: string;
  createdAt?: string;
  updatedAt?: string;
  userPostDataInfo?: {
    name: string;
    emailId: string;
    role: string;
    createdAt: string;
    updatedAt: string;
  }[];
}

const initialDeveloperState: Developer = {
  developerName: "",
  developerDescriptionLeft: "",
  developerDescriptionRight: "",
  isPublished: false,
  teamTiaUp: false,
  employerReviewUserId: "",
  developerImages: [],
  developerGallery: [],
  developerSlug: "",
  developerLogo: "",
  developerWebsite: "",
  developerHeadquarters: "",
  developereStablishedYear: "",
  developerContactNumbers: [],
  developerEmail: [],
  developerAddress: "",
  teamAssementPdfModule: [],
};

const getImageUrl = (path?: string) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `https://service.ireedindia.com/image/${path}`;
};

const DeveloperDashboard = () => {
  const storedUser = localStorage.getItem("userDetails");
  const userDetails = storedUser ? JSON.parse(storedUser) : null;
  const role = userDetails?.role;

  const [developers, setDevelopers] = useState<Developer[]>([]);
  // NEW: State for the search API results
  const [companyUsers, setCompanyUsers] = useState<{ _id: string; name: string }[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingDeveloper, setEditingDeveloper] = useState<Developer | null>(null);
  const [formData, setFormData] = useState<Developer>(initialDeveloperState);
  const [logoPreview, setLogoPreview] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [publishFilter, setPublishFilter] = useState<'all' | 'published' | 'unpublished'>('all');

  const uploadImageToAPI = async (file: File): Promise<string> => {
    const fd = new FormData();
    fd.append("file", file);
    const res = await fetch("https://service.ireedindia.com/upload", {
      method: "POST",
      body: fd,
    });
    if (!res.ok) throw new Error("Upload failed");
    const data = await res.json();
    return data.filename;
  };

  const replaceImageToAPI = async (file: File, oldFilename: string): Promise<string> => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("oldFilenames", oldFilename);
    const res = await fetch("https://service.ireedindia.com/replace-files", {
      method: "PATCH",
      body: fd,
    });
    if (!res.ok) throw new Error("Replace failed");
    const data = await res.json();
    return data.uploadedFiles;
  };

  // NEW: Fetch users from search API
  const fetchCompanyUsers = async () => {
    try {
      const res = await fetch("https://service.ireedindia.com/v1/users/search", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          pageNumber: "0",
          size: "40",
          role: ["company"]
        }),
      });
      const data = await res.json();
      const users = data.content || data.data || (Array.isArray(data) ? data : []);
      setCompanyUsers(users);
    } catch (err) {
      console.error("❌ User search error:", err);
    }
  };

  const fetchDevelopers = async () => {
    setIsLoading(true);
    try {
      const userId = userDetails?.userId;
      let apiUrl = "https://service.ireedindia.com/v1/developers-all?page=1&limit=1000";
      if (role !== "admin" && userId) {
        apiUrl += `?userId=${userId}`;
      }
      const res = await fetch(apiUrl);
      const data = await res.json();
      if (Array.isArray(data)) setDevelopers(data);
      else if (data.developers) setDevelopers(data.developers);
      else if (data.data) setDevelopers(data.data);
    } catch (err) {
      console.error("❌ Fetch error:", err);
      alert("Failed to fetch developers");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => { 
    fetchDevelopers(); 
    fetchCompanyUsers(); // Load users on mount
  }, []);

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      const userId = userDetails?.userId;
      const url = editingDeveloper
        ? `https://service.ireedindia.com/v1/developers/${editingDeveloper.id || editingDeveloper._id}`
        : "https://service.ireedindia.com/v1/developer-create";
      const method = editingDeveloper ? "PATCH" : "POST";

      let payload: any = { ...formData };
      if (role !== "admin" && userId) {
        payload.userId = userId;
      }

      if (userDetails && !editingDeveloper) {
        payload.userPostDataInfo = [
          {
            name: userDetails.name || userDetails.username || userDetails.emailId || "",
            emailId: userDetails.emailId || userDetails.email || "",
            role: userDetails.role || "",
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
          },
        ];
      }

      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Save failed");

      alert(`Developer ${editingDeveloper ? "updated" : "created"} successfully`);
      resetForm();
      setIsModalOpen(false);
      fetchDevelopers();
    } catch (err) {
      console.error("❌ Save error:", err);
      alert("Save failed");
    } finally {
      setIsLoading(false);
    }
  };

  const resetForm = useCallback(() => {
    setFormData(initialDeveloperState);
    setLogoPreview("");
    setEditingDeveloper(null);
  }, []);

  const handleDelete = async (id?: string) => {
    if (!id || !window.confirm("Are you sure to delete this developer?")) return;
    if (role !== "admin") {
      alert("Only administrators can delete developers");
      return;
    }
    try {
      setIsLoading(true);
      const res = await fetch(`https://service.ireedindia.com/v1/developers/${id}`, {
        method: "DELETE",
      });
      if (!res.ok) throw new Error("Delete failed");
      alert("Deleted successfully");
      fetchDevelopers();
    } catch (err) {
      console.error("❌ Delete error:", err);
      alert("Delete failed");
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = (dev: Developer) => {
    setEditingDeveloper(dev);
    setFormData({ ...dev, teamAssementPdfModule: dev.teamAssementPdfModule || [] });
    setLogoPreview(getImageUrl(dev.developerLogo));
    setIsModalOpen(true);
  };

  const handleLogoUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    try {
      setIsLoading(true);
      let filename: string;
      if (editingDeveloper && formData.developerLogo) {
        filename = await replaceImageToAPI(file, formData.developerLogo);
        alert("Logo replaced successfully");
      } else {
        filename = await uploadImageToAPI(file);
      }
      setFormData({ ...formData, developerLogo: filename });
      setLogoPreview(getImageUrl(filename));
    } catch (err) {
      console.error("Logo upload failed", err);
      alert("Logo upload failed");
    } finally {
      setIsLoading(false);
    }
  };

  const handleImagesUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files) return;
    try {
      const uploadPromises = Array.from(files).map(uploadImageToAPI);
      const filenames = await Promise.all(uploadPromises);
      setFormData((prev) => ({
        ...prev,
        developerImages: [...prev.developerImages, ...filenames],
      }));
    } catch {
      alert("Images upload failed");
    }
  };

  const handleImageReplace = async (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const oldFilename = formData.developerImages[index];
    if (!oldFilename) return;
    try {
      setIsLoading(true);
      const newFilename = await replaceImageToAPI(file, oldFilename);
      const updatedImages = [...formData.developerImages];
      updatedImages[index] = newFilename;
      setFormData({ ...formData, developerImages: updatedImages });
      alert("Image replaced successfully");
    } catch (err) {
      alert("Image replace failed");
    } finally {
      setIsLoading(false);
    }
  };

  const handleGalleryUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files) return;
    try {
      const uploadPromises = Array.from(files).map(uploadImageToAPI);
      const filenames = await Promise.all(uploadPromises);
      const galleryItems = filenames.map((f) => ({ img: f, title: "", subTitle: "" }));
      setFormData((prev) => ({
        ...prev,
        developerGallery: [...prev.developerGallery, ...galleryItems],
      }));
    } catch {
      alert("Gallery upload failed");
    }
  };

  const handleGalleryImageReplace = async (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const oldFilename = formData.developerGallery[index].img;
    if (!oldFilename) return;
    try {
      setIsLoading(true);
      const newFilename = await replaceImageToAPI(file, oldFilename);
      const updatedGallery = [...formData.developerGallery];
      updatedGallery[index].img = newFilename;
      setFormData({ ...formData, developerGallery: updatedGallery });
      alert("Gallery image replaced successfully");
    } catch (err) {
      alert("Gallery image replace failed");
    } finally {
      setIsLoading(false);
    }
  };

  // ── Assessment PDF handlers ──────────────────────────────────────────────
  const handleAssessmentPdfUpload = async (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const file = e.target.files?.[0];
    if (!file) return;
    try {
      setIsLoading(true);
      const fd = new FormData();
      fd.append("file", file);
      const res = await fetch("https://service.ireedindia.com/upload", {
        method: "POST",
        body: fd,
      });
      if (!res.ok) throw new Error("Upload failed");
      const data = await res.json();
      const filename: string = data.filename;
      const updated = [...formData.teamAssementPdfModule];
      updated[index] = { ...updated[index], pdf: filename };
      setFormData({ ...formData, teamAssementPdfModule: updated });
    } catch (err) {
      console.error("PDF upload failed", err);
      alert("PDF upload failed");
    } finally {
      setIsLoading(false);
    }
  };

  const handleAssessmentPdfReplace = async (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const oldFilename = formData.teamAssementPdfModule[index].pdf;
    if (!oldFilename) return;
    try {
      setIsLoading(true);
      const newFilename = await replaceImageToAPI(file, oldFilename);
      const updated = [...formData.teamAssementPdfModule];
      updated[index] = { ...updated[index], pdf: newFilename };
      setFormData({ ...formData, teamAssementPdfModule: updated });
      alert("PDF replaced successfully");
    } catch (err) {
      alert("PDF replace failed");
    } finally {
      setIsLoading(false);
    }
  };
  // ────────────────────────────────────────────────────────────────────────

  let filteredDevelopers = developers.filter(d =>
    d.developerName.toLowerCase().includes(searchQuery.toLowerCase())
  );
  if (role === 'admin' && publishFilter !== 'all') {
    filteredDevelopers = filteredDevelopers.filter(d =>
      publishFilter === 'published' ? d.isPublished : !d.isPublished
    );
  }

  return (
    <div style={{ minHeight: "100vh", background: "#f5f7fa", padding: "24px" }}>
      <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
        {/* Header */}
        <div style={{ background: "white", padding: "24px", borderRadius: "12px", marginBottom: "24px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "16px" }}>
            <div>
              <h1 style={{ margin: 0, fontSize: "28px", color: "#1a202c", fontWeight: "600" }}>Developer Dashboard</h1>
              <p style={{ margin: "4px 0 0 0", color: "#64748b", fontSize: "14px" }}>Manage real estate developers</p>
            </div>
            <div style={{ display: "flex", gap: "12px" }}>
              <div style={{ textAlign: "center", background: "#f8fafc", padding: "12px 20px", borderRadius: "8px", border: "1px solid #e2e8f0" }}>
                <div style={{ fontSize: "24px", fontWeight: "600", color: "#1e293b" }}>{developers.length}</div>
                <div style={{ fontSize: "11px", color: "#64748b", marginTop: "2px" }}>Total</div>
              </div>
              <div style={{ textAlign: "center", background: "#f0fdf4", padding: "12px 20px", borderRadius: "8px", border: "1px solid #bbf7d0" }}>
                <div style={{ fontSize: "24px", fontWeight: "600", color: "#15803d" }}>{developers.filter(d => d.isPublished).length}</div>
                <div style={{ fontSize: "11px", color: "#15803d", marginTop: "2px" }}>Published</div>
              </div>
              <div style={{ textAlign: "center", background: "#fef2f2", padding: "12px 20px", borderRadius: "8px", border: "1px solid #fecaca" }}>
                <div style={{ fontSize: "24px", fontWeight: "600", color: "#dc2626" }}>{developers.filter(d => !d.isPublished).length}</div>
                <div style={{ fontSize: "11px", color: "#dc2626", marginTop: "2px" }}>Draft</div>
              </div>
            </div>
          </div>
        </div>

        {/* Controls */}
        <div style={{ background: "white", padding: "20px", borderRadius: "12px", marginBottom: "24px", display: "flex", justifyContent: "space-between", alignItems: "center", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", flexWrap: "wrap", gap: "12px" }}>
          <button onClick={() => { resetForm(); setIsModalOpen(true); }} style={{ padding: "12px 24px", background: "#3b82f6", color: "white", border: "none", borderRadius: "8px", fontSize: "14px", fontWeight: "500", cursor: "pointer" }}>
            + Add Developer
          </button>
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            <input
              type="text"
              placeholder="Search developers..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{ padding: "10px 16px", width: "300px", border: "1px solid #e2e8f0", borderRadius: "8px", fontSize: "14px" }}
            />
            {searchQuery && (
              <button onClick={() => setSearchQuery("")} style={{ padding: "10px 16px", background: "#f1f5f9", color: "#475569", border: "none", borderRadius: "8px", fontSize: "13px", cursor: "pointer" }}>
                Clear
              </button>
            )}
            {role === 'admin' && (
              <div style={{ marginLeft: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontWeight: 500, fontSize: 15 }}>Filter:</span>
                <select
                  value={publishFilter}
                  onChange={e => setPublishFilter(e.target.value as 'all' | 'published' | 'unpublished')}
                  style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #d1d5db', fontSize: 15 }}
                >
                  <option value="all">All</option>
                  <option value="published">Published</option>
                  <option value="unpublished">Unpublished</option>
                </select>
              </div>
            )}
          </div>
        </div>

        {/* Table */}
        <div style={{ background: "white", borderRadius: "12px", overflow: "auto", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
            <thead>
              <tr style={{ background: "linear-gradient(to right, #4f46e5, #7c3aed)", color: "white" }}>
                <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600" }}>Developer</th>
                <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600" }}>Location</th>
                <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600" }}>Contact</th>
                <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600" }}>Media & Gallery</th>
                {role === "admin" && (
                  <>
                    <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600" }}>Created By</th>
                    <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600" }}>Created At</th>
                    <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600" }}>Updated At</th>
                  </>
                )}
                <th style={{ padding: "14px 0px", textAlign: "center", fontSize: "13px", fontWeight: "600" }}>Status</th>
                <th style={{ padding: "14px 16px", textAlign: "center", fontSize: "13px", fontWeight: "600" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredDevelopers.map((d) => (
                <tr key={d.id || d._id} style={{ borderBottom: "1px solid #e5e7eb" }}>
                  <td style={{ padding: "14px 16px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                      {d.developerLogo ? (
                        <img src={getImageUrl(d.developerLogo)} alt="logo" style={{ width: "48px", height: "48px", objectFit: "contain", borderRadius: "8px", border: "1px solid #e5e7eb", background: "white", padding: "4px" }} />
                      ) : (
                        <div style={{ width: "48px", height: "48px", background: "#f3f4f6", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "20px" }}>🏢</div>
                      )}
                      <div>
                        <div style={{ fontWeight: "600", fontSize: "14px", color: "#111827" }}>{d.developerName}</div>
                        <div style={{ fontSize: "12px", color: "#6b7280" }}>Est. {d.developereStablishedYear || "N/A"}</div>
                      </div>
                    </div>
                  </td>
                  <td style={{ padding: "14px 16px", fontSize: "13px" }}>
                    <div>{d.developerHeadquarters || "N/A"}</div>
                    {d.developerWebsite && <a href={d.developerWebsite} target="_blank" rel="noopener noreferrer" style={{ fontSize: "12px", color: "#4f46e5" }}>View Website →</a>}
                  </td>
                  <td style={{ padding: "14px 16px", fontSize: "13px" }}>
                    {d.developerContactNumbers?.[0] && <div>📞 {d.developerContactNumbers[0]}</div>}
                    {d.developerEmail?.[0] && <div style={{ fontSize: "12px", color: "#6b7280" }}>✉️ {d.developerEmail[0]}</div>}
                  </td>
                  <td style={{ padding: "14px 16px" }}>
                    <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                      {d.developerImages?.slice(0, 3).map((img, idx) => (
                        <img key={idx} src={getImageUrl(img)} style={{ width: "32px", height: "32px", objectFit: "cover", borderRadius: "4px" }} alt="media" />
                      ))}
                    </div>
                  </td>
                  {role === "admin" && (
                    <>
                      <td style={{ padding: "14px 16px", fontSize: "13px" }}>{d.userPostDataInfo?.[0]?.name || "N/A"}</td>
                      <td style={{ padding: "14px 16px", fontSize: "12px" }}>{d.userPostDataInfo?.[0]?.createdAt ? new Date(d.userPostDataInfo[0].createdAt).toLocaleDateString() : "N/A"}</td>
                      <td style={{ padding: "14px 16px", fontSize: "12px" }}>{d.userPostDataInfo?.[0]?.updatedAt ? new Date(d.userPostDataInfo[0].updatedAt).toLocaleDateString() : "N/A"}</td>
                    </>
                  )}
                  <td style={{ padding: "14px 12px", textAlign: "center" }}>
                    <span style={{ padding: "4px 8px", background: d.isPublished ? "#10b981" : "#ef4444", color: "white", borderRadius: "20px", fontSize: "11px", fontWeight: "600" }}>
                      {d.isPublished ? "✓ Published" : "✕ Draft"}
                    </span>
                  </td>
                  <td style={{ padding: "14px 16px", textAlign: "center" }}>
                    <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
                      <button onClick={() => handleEdit(d)} style={{ padding: "6px 12px", background: "#4f46e5", color: "white", border: "none", borderRadius: "6px", fontSize: "12px", cursor: "pointer" }}>Edit</button>
                      {role === "admin" && (
                        <button onClick={() => handleDelete(d.id || d._id)} style={{ padding: "6px 12px", background: "#ef4444", color: "white", border: "none", borderRadius: "6px", fontSize: "12px", cursor: "pointer" }}>Delete</button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Modal */}
        {isModalOpen && (
          <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000, padding: "20px" }}>
            <div style={{ background: "white", borderRadius: "16px", width: "100%", maxWidth: "900px", maxHeight: "90vh", overflow: "auto" }}>
              {/* Modal Header */}
              <div style={{ padding: "24px", borderBottom: "1px solid #e2e8f0", position: "sticky", top: 0, background: "white", zIndex: 10 }}>
                <h2 style={{ margin: 0, fontSize: "24px", color: "#1a202c", fontWeight: "600" }}>
                  {editingDeveloper ? "Edit Developer" : "Add New Developer"}
                </h2>
              </div>

              {/* Modal Body */}
              <div style={{ padding: "24px" }}>
                {/* Basic Information */}
                <Section title="Basic Information">
                  <FormField label="Developer Name" required>
                    <input value={formData.developerName} onChange={(e) => setFormData({ ...formData, developerName: e.target.value })} style={inputStyle} placeholder="Enter developer name" />
                  </FormField>

                  <FormField label="Slug" required>
                    <input value={formData.developerSlug} onChange={(e) => setFormData({ ...formData, developerSlug: e.target.value })} style={inputStyle} placeholder="developer-slug" />
                  </FormField>

                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                    <FormField label="Website" required>
                      <input value={formData.developerWebsite} onChange={(e) => setFormData({ ...formData, developerWebsite: e.target.value })} style={inputStyle} placeholder="https://example.com" />
                    </FormField>
                    <FormField label="Established Year" required>
                      <input value={formData.developereStablishedYear} onChange={(e) => setFormData({ ...formData, developereStablishedYear: e.target.value })} style={inputStyle} placeholder="2020" />
                    </FormField>
                  </div>

                  <FormField label="Headquarters" required>
                    <input value={formData.developerHeadquarters} onChange={(e) => setFormData({ ...formData, developerHeadquarters: e.target.value })} style={inputStyle} placeholder="City, Country" />
                  </FormField>

                  <FormField label="Address" required>
                    <textarea value={formData.developerAddress} onChange={(e) => setFormData({ ...formData, developerAddress: e.target.value })} style={{ ...inputStyle, minHeight: "80px" }} placeholder="Full address" rows={3} />
                  </FormField>
                </Section>

                {/* Description */}
                <Section title="Description">
                  <FormField label="Description Left" required>
                    <textarea value={formData.developerDescriptionLeft} onChange={(e) => setFormData({ ...formData, developerDescriptionLeft: e.target.value })} style={{ ...inputStyle, minHeight: "120px" }} placeholder="Enter left description 50 words" rows={5} />
                  </FormField>
                  <FormField label="Description Right" required>
                    <textarea value={formData.developerDescriptionRight} onChange={(e) => setFormData({ ...formData, developerDescriptionRight: e.target.value })} style={{ ...inputStyle, minHeight: "120px" }} placeholder="Enter right description 95 words" rows={5} />
                  </FormField>
                </Section>

                {/* Contact Information */}
                <Section title="Contact Information">
                  <FormField label="Contact Numbers" required>
                    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                      {formData.developerContactNumbers.map((num, i) => (
                        <div key={i} style={{ display: "flex", gap: "8px" }}>
                          <input value={num} onChange={(e) => {
                            const updated = [...formData.developerContactNumbers];
                            updated[i] = e.target.value;
                            setFormData({ ...formData, developerContactNumbers: updated });
                          }} style={{ ...inputStyle, flex: 1 }} />
                          <button onClick={() => {
                            const updated = formData.developerContactNumbers.filter((_, idx) => idx !== i);
                            setFormData({ ...formData, developerContactNumbers: updated });
                          }} style={removeBtn}>Remove</button>
                        </div>
                      ))}
                      <button onClick={() => setFormData({ ...formData, developerContactNumbers: [...formData.developerContactNumbers, ""] })} style={addBtn}>+ Add Contact Number</button>
                    </div>
                  </FormField>

                  <FormField label="Email Addresses" required>
                    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                      {formData.developerEmail.map((email, i) => (
                        <div key={i} style={{ display: "flex", gap: "8px" }}>
                          <input value={email} onChange={(e) => {
                            const updated = [...formData.developerEmail];
                            updated[i] = e.target.value;
                            setFormData({ ...formData, developerEmail: updated });
                          }} style={{ ...inputStyle, flex: 1 }} />
                          <button onClick={() => {
                            const updated = formData.developerEmail.filter((_, idx) => idx !== i);
                            setFormData({ ...formData, developerEmail: updated });
                          }} style={removeBtn}>Remove</button>
                        </div>
                      ))}
                      <button onClick={() => setFormData({ ...formData, developerEmail: [...formData.developerEmail, ""] })} style={addBtn}>+ Add Email</button>
                    </div>
                  </FormField>
                </Section>

                {/* Media */}
                <Section title="Media">
                  <FormField label="Logo" required>
                    <div style={{ border: "2px dashed #e2e8f0", padding: "24px", borderRadius: "12px", textAlign: "center", background: "#fafbfc" }}>
                      <input type="file" accept="image/*" onChange={handleLogoUpload} style={{ marginBottom: "12px" }} />
                      {logoPreview && (
                        <div style={{ marginTop: "16px" }}>
                          <img src={logoPreview} style={{ maxWidth: "150px", maxHeight: "150px", objectFit: "contain", border: "1px solid #e2e8f0", borderRadius: "8px", padding: "8px", background: "white" }} alt="Logo preview" />
                        </div>
                      )}
                    </div>
                  </FormField>

                  <FormField label="Developer Images">
                    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))", gap: "12px" }}>
                        {formData.developerImages.map((img, i) => (
                          <div key={i} style={{ position: "relative", borderRadius: "8px", overflow: "hidden", border: "1px solid #e2e8f0" }}>
                            <img src={getImageUrl(img)} style={{ width: "100%", height: "120px", objectFit: "cover" }} alt="media" />
                            <div style={{ position: "absolute", top: "4px", right: "4px", display: "flex", gap: "4px" }}>
                              <button onClick={() => {
                                const updated = formData.developerImages.filter((_, idx) => idx !== i);
                                setFormData({ ...formData, developerImages: updated });
                              }} style={{ background: "#ef4444", color: "white", border: "none", borderRadius: "4px", cursor: "pointer", padding: "4px 8px" }}>×</button>
                            </div>
                          </div>
                        ))}
                      </div>
                      <input type="file" accept="image/*" multiple onChange={handleImagesUpload} id="developer-images-upload" style={{ display: "none" }} />
                      <button onClick={() => (document.getElementById('developer-images-upload') as HTMLInputElement)?.click()} style={addBtn}>+ Add Images</button>
                    </div>
                  </FormField>

                  <FormField label="Gallery">
                    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "16px" }}>
                        {formData.developerGallery.map((g, i) => (
                          <div key={i} style={{ border: "1px solid #e2e8f0", borderRadius: "12px", padding: "12px", background: "white" }}>
                            <img src={getImageUrl(g.img)} style={{ width: "100%", height: "140px", objectFit: "cover", borderRadius: "8px", marginBottom: "8px" }} alt="gallery" />
                            <input placeholder="Title" value={g.title} onChange={(e) => {
                              const updated = [...formData.developerGallery];
                              updated[i].title = e.target.value;
                              setFormData({ ...formData, developerGallery: updated });
                            }} style={{ ...inputStyle, marginBottom: "8px" }} />
                            <input placeholder="Subtitle" value={g.subTitle} onChange={(e) => {
                              const updated = [...formData.developerGallery];
                              updated[i].subTitle = e.target.value;
                              setFormData({ ...formData, developerGallery: updated });
                            }} style={{ ...inputStyle, marginBottom: "8px" }} />
                            <button onClick={() => {
                              const updated = formData.developerGallery.filter((_, idx) => idx !== i);
                              setFormData({ ...formData, developerGallery: updated });
                            }} style={{ ...removeBtn, width: "100%", justifyContent: "center" }}>Remove</button>
                          </div>
                        ))}
                      </div>
                      <input type="file" accept="image/*" multiple onChange={handleGalleryUpload} id="gallery-upload" style={{ display: "none" }} />
                      <button onClick={() => (document.getElementById('gallery-upload') as HTMLInputElement)?.click()} style={addBtn}>+ Add Gallery Images</button>
                    </div>
                  </FormField>
                </Section>

                {/* ── Assessment PDF Module ─────────────────────────────── */}
                <Section title="Assessment PDF Module">
                  <FormField label="Team Assessment PDFs">
                    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                      {formData.teamAssementPdfModule.map((item, i) => (
                        <div
                          key={i}
                          style={{
                            border: "1px solid #e2e8f0",
                            borderRadius: "12px",
                            padding: "16px",
                            background: "#fafbfc",
                            display: "flex",
                            flexDirection: "column",
                            gap: "12px",
                          }}
                        >
                          {/* Title input */}
                          <input
                            placeholder="PDF Title"
                            value={item.title}
                            onChange={(e) => {
                              const updated = [...formData.teamAssementPdfModule];
                              updated[i] = { ...updated[i], title: e.target.value };
                              setFormData({ ...formData, teamAssementPdfModule: updated });
                            }}
                            style={inputStyle}
                          />

                          {/* PDF file row */}
                          <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
                            {item.pdf ? (
                              <>
                                {/* Existing PDF indicator */}
                                <div style={{ display: "flex", alignItems: "center", gap: "6px", padding: "8px 12px", background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: "8px", fontSize: "13px", color: "#1d4ed8" }}>
                                  📄 <span style={{ maxWidth: "180px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{item.pdf}</span>
                                </div>
                                {/* Replace PDF */}
                                <label style={{ ...addBtn, cursor: "pointer", display: "inline-block" }}>
                                  Replace PDF
                                  <input
                                    type="file"
                                    accept="application/pdf"
                                    style={{ display: "none" }}
                                    onChange={(e) => handleAssessmentPdfReplace(e, i)}
                                  />
                                </label>
                              </>
                            ) : (
                              /* Upload PDF */
                              <label style={{ ...addBtn, cursor: "pointer", display: "inline-block" }}>
                                + Upload PDF
                                <input
                                  type="file"
                                  accept="application/pdf"
                                  style={{ display: "none" }}
                                  onChange={(e) => handleAssessmentPdfUpload(e, i)}
                                />
                              </label>
                            )}
                          </div>

                          {/* Remove entry */}
                          <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            <button
                              onClick={() => {
                                const updated = formData.teamAssementPdfModule.filter((_, idx) => idx !== i);
                                setFormData({ ...formData, teamAssementPdfModule: updated });
                              }}
                              style={removeBtn}
                            >
                              Remove
                            </button>
                          </div>
                        </div>
                      ))}

                      {/* Add new entry */}
                      <button
                        onClick={() =>
                          setFormData({
                            ...formData,
                            teamAssementPdfModule: [
                              ...formData.teamAssementPdfModule,
                              { title: "", pdf: "" },
                            ],
                          })
                        }
                        style={addBtn}
                      >
                        + Add Assessment PDF
                      </button>
                    </div>
                  </FormField>
                </Section>
                {/* ───────────────────────────────────────────────────────── */}

                <FormField label="Employer Review User">
                  {/* API INTEGRATED SELECT */}
                  <select 
                    value={formData.employerReviewUserId} 
                    onChange={(e) => setFormData({ ...formData, employerReviewUserId: e.target.value })} 
                    style={{ ...inputStyle, appearance: "auto" }}
                  >
                    <option value="">Select a User</option>
                    {companyUsers.map((user) => (
                      <option key={user._id} value={user._id}>
                        {user.name}
                      </option>
                    ))}
                  </select>
                </FormField>

                {role === "admin" && (
                  <Section title="Publishing & Partnerships">
                    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                      <label style={{ display: "flex", alignItems: "center", gap: "12px", cursor: "pointer" }}>
                        <input type="checkbox" checked={formData.isPublished} onChange={(e) => setFormData({ ...formData, isPublished: e.target.checked })} style={{ width: "20px", height: "20px" }} />
                        <span style={{ fontSize: "14px", fontWeight: "500" }}>Publish this developer</span>
                      </label>
                      <label style={{ display: "flex", alignItems: "center", gap: "12px", cursor: "pointer" }}>
                        <input type="checkbox" checked={formData.teamTiaUp} onChange={(e) => setFormData({ ...formData, teamTiaUp: e.target.checked })} style={{ width: "20px", height: "20px" }} />
                        <span style={{ fontSize: "14px", fontWeight: "500" }}>Team Tia Up</span>
                      </label>
                    </div>
                  </Section>
                )}
              </div>

              {/* Modal Footer */}
              <div style={{ padding: "20px 24px", borderTop: "1px solid #e2e8f0", display: "flex", justifyContent: "flex-end", gap: "12px", position: "sticky", bottom: 0, background: "white" }}>
                <button onClick={() => setIsModalOpen(false)} style={{ padding: "12px 24px", background: "#f1f5f9", color: "#475569", border: "none", borderRadius: "8px", cursor: "pointer" }}>Cancel</button>
                <button onClick={handleSubmit} disabled={isLoading} style={{ padding: "12px 24px", background: "#3b82f6", color: "white", border: "none", borderRadius: "8px", cursor: "pointer" }}>
                  {isLoading ? "Saving..." : editingDeveloper ? "Update Developer" : "Create Developer"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const Section = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <div style={{ marginBottom: "32px" }}>
    <div style={{ marginBottom: "20px" }}>
      <h3 style={{
        fontSize: "16px",
        fontWeight: "600",
        color: "#1e293b",
        background: "linear-gradient(90deg, transparent 0%, #dbeafe 20%, #dbeafe 80%, transparent 100%)",
        padding: "10px 20px",
        borderRadius: "24px",
        display: "inline-block"
      }}>{title}</h3>
    </div>
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>{children}</div>
  </div>
);

const FormField = ({ label, required, children }: { label: string; required?: boolean; children: React.ReactNode }) => (
  <div>
    <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "500", color: "#475569" }}>
      {label} {required && <span style={{ color: "#ef4444" }}>*</span>}
    </label>
    {children}
  </div>
);

const inputStyle: React.CSSProperties = {
  width: "100%",
  padding: "10px 14px",
  border: "1px solid #e2e8f0",
  borderRadius: "8px",
  fontSize: "14px",
};

const addBtn: React.CSSProperties = {
  padding: "10px 18px",
  background: "#f1f5f9",
  color: "#475569",
  border: "1px solid #e2e8f0",
  borderRadius: "8px",
  fontSize: "13px",
  cursor: "pointer",
};

const removeBtn: React.CSSProperties = {
  padding: "10px 18px",
  background: "#fee2e2",
  color: "#dc2626",
  border: "none",
  borderRadius: "8px",
  fontSize: "13px",
  cursor: "pointer",
};

export default DeveloperDashboard;